import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/grailed-seller-initiated-offers';

export default function Example() {
  return (
    <>
      <Head>
        <title>How to Earn More With Grailed Seller Initiated Offers</title>
        <meta
          name='description'
          content='Learn how to maximize your earning potential and make sales by creating seller-initiated offers that work! Find out how to give your potential buyers the best deals and gain more visibility for your business.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/grailed-seller-initiated-offers' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/grailed-seller-initiated-offers' />
        <meta property='og:title' content='How to Earn More With Grailed Seller Initiated Offers' />
        <meta
          property='og:description'
          content='Learn how to maximize your earning potential and make sales by creating seller-initiated offers that work! Find out how to give your potential buyers the best deals and gain more visibility for your business.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-06-05T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-06-05T00:00:00-00:00' />
        <meta property='article:tag' content='Grailed' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
